import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from '../app-routing/app-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RoomReservationComponent } from './room-reservation.component';
import { FormsModule } from '@angular/forms';
import { MultiDropdownComponent } from '../../shared/components/multi-dropdown/multi-dropdown.component';
import { FormGroupComponent } from '../../shared/components/form-group/form-group.component';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { TableComponent } from '../../shared/components/table/table.component';
import { SpinnerComponent } from '../../shared/components/spinner/spinner.component';
import { SpinnerOverlayComponent } from '../../shared/components/spinner-overlay/spinner-overlay.component';
import { MyReservationComponent } from './components/my-reservation/my-reservation.component';
import { CustomNgbDateParserFormatter } from '../../shared/models/custom-ngb-date-parser-formatter';
import { RoomReservationBookmarksComponent } from './components/room-reservation-bookmarks/room-reservation-bookmarks.component';
import { ModalDialogComponent, ModalDialogFocusDirective } from '../../shared/components/modal-dialog/modal-dialog.component';
import { TooltipButtonComponent } from '../../shared/components/button/tooltip-button.component';
import { RoomInfoComponent } from './components/room-info/room-info.component';
import { RoomAllocationTableComponent } from './components/room-allocation-table/room-allocation-table.component';
import { RoomAllocationDesktopComponent } from './components/room-allocation-table/room-allocation-desktop.component';
import { RoomAllocationMobileComponent } from './components/room-allocation-table/room-allocation-mobile.component';
import { RoomScheduleComponent } from './components/room-schedule/room-schedule.component';
import { CollapsibleScheduleComponent } from './components/collapsible-schedule/collapsible-schedule.component';
import { RoomScheduleItemComponent } from './components/room-schedule-item/room-schedule-item.component';
import { CreateRoomReservationDialogComponent } from './components/create-reservation-dialog/create-room-reservation-dialog.component';
import { CreateReservationDateComponent } from './components/create-reservation-date/create-reservation-date.component';
import { MessageComponent } from 'src/app/shared/components/message/message.component';
import { MessagesComponent } from 'src/app/shared/components/messages/messages.component';
import { ConfirmReservationDialogComponent } from './components/confirm-reservation-dialog/confirm-reservation-dialog.component';
import { EventoDatePipe } from 'src/app/shared/pipes/evento-date.pipe';
import { EventoTimePipe } from 'src/app/shared/pipes/evento-time.pipe';
import { EventoDayShortPipe } from 'src/app/shared/pipes/evento-day-short.pipe';
import { EventoDayPipe } from 'src/app/shared/pipes/evento-day.pipe';
import { CreateReservationIntervalComponent } from './components/create-reservation-interval/create-reservation-interval.component';
import { DebugMultiDropdownComponent } from 'src/app/shared/components/debug-multi-dropdown/debug-multi-dropdown.component';
import { AccordionDirective } from 'src/app/shared/components/accordion/accordion.directive';
import { AccordionElementDirective } from 'src/app/shared/components/accordion/accordion-element.directive';
import { AccordionElementHeaderDirective } from 'src/app/shared/components/accordion/accordion-element-header.directive';
import { AccordionElementBodyComponent } from 'src/app/shared/components/accordion/accordion-element-body.component';
import { AccordionElementTriggerDirective } from 'src/app/shared/components/accordion/accordion-element-trigger.directive';
import { DeviceReservationComponent } from './device-reservation.component';
import { MainSearchInputComponent } from './components/main-search-input/main-search-input.component';
import { DeviceInfoComponent } from './components/room-info/device-info.component';
import { CreateDeviceReservationDialogComponent } from './components/create-reservation-dialog/create-device-reservation-dialog.component';
import { StartPageComponent } from './components/start-page/start-page.component';
import { TimeComboBoxComponent } from 'src/app/shared/components/time-combo-box/time-combo-box.component';
import { SearchTermsFavorizerComponent } from 'src/app/shared/components/search-terms-favorizer/search-terms-favorizer.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FormsModule,
    TranslateModule,
    NgbModule.forRoot(),
    AppRoutingModule
  ],
  declarations: [
    StartPageComponent,
    RoomReservationComponent,
    DeviceReservationComponent,
    MultiDropdownComponent,
    FormGroupComponent,
    SpinnerComponent,
    SpinnerOverlayComponent,
    ButtonComponent,
    TableComponent,
    MyReservationComponent,
    RoomReservationBookmarksComponent,
    ModalDialogComponent,
    ModalDialogFocusDirective,
    TooltipButtonComponent,
    RoomInfoComponent,
    DeviceInfoComponent,
    RoomAllocationTableComponent,
    RoomAllocationDesktopComponent,
    RoomAllocationMobileComponent,
    RoomScheduleComponent,
    RoomScheduleItemComponent,
    CollapsibleScheduleComponent,
    CreateRoomReservationDialogComponent,
    CreateDeviceReservationDialogComponent,
    CreateReservationDateComponent,
    MessageComponent,
    MessagesComponent,
    ConfirmReservationDialogComponent,
    EventoDatePipe,
    EventoTimePipe,
    EventoDayShortPipe,
    EventoDayPipe,
    CreateReservationIntervalComponent,
    DebugMultiDropdownComponent,
    MainSearchInputComponent,
    AccordionDirective,
    AccordionElementDirective,
    AccordionElementHeaderDirective,
    AccordionElementBodyComponent,
    AccordionElementTriggerDirective,
    TimeComboBoxComponent,
    SearchTermsFavorizerComponent
  ],
  exports: [
    StartPageComponent,
    RoomReservationComponent,
    DeviceReservationComponent,
    MessageComponent,
    MessagesComponent
  ],
  providers: [
    CustomNgbDateParserFormatter,
    EventoDayShortPipe,
    EventoDatePipe
  ]
})
export class RoomReservationModule { }
